/*
 * OfferValue Constants
 */

export const LOAD_DELIVERY_TIMES = 'ideal/OfferValue/LOAD_DELIVERY_TIMES';
export const LOAD_BROKERS = 'ideal/OfferValue/LOAD_BROKERS';
export const LOAD_PRODUCTS = 'ideal/OfferValue/LOAD_PRODUCTS';
export const SET_OFFER_MONTHLY_RATE = 'ideal/OfferValue/SET_OFFER_MONTHLY_RATE';
export const SET_OFFER_DEPOSIT = 'ideal/OfferValue/SET_OFFER_DEPOSIT';
export const SET_OFFER_DURATION = 'ideal/OfferValue/SET_OFFER_DURATION';
export const SET_OFFER_RIGHT_LABEL = 'ideal/OfferValue/SET_OFFER_RIGHT_LABEL';
export const SET_OFFER_DISTANCE = 'ideal/OfferValue/SET_OFFER_DISTANCE';
export const SET_OFFER_NOTES = 'ideal/OfferValue/SET_OFFER_NOTES';
export const SET_OFFER_PRIVATE_NOTES = 'ideal/OfferValue/SET_OFFER_PRIVATE_NOTES';
export const SET_OFFER_REFERENCE = 'ideal/OfferValue/SET_OFFER_REFERENCE';
export const SET_OFFER_FAST_DELIVERY = 'ideal/OfferValue/SET_OFFER_FAST_DELIVERY';
export const SET_OFFER_DELIVERY_TIME = 'ideal/OfferValue/SET_OFFER_DELIVERY_TIME';
export const SET_OFFER_DELIVERY_TIMES = 'ideal/OfferValue/SET_OFFER_DELIVERY_TIMES';
export const SET_OFFER_BROKERS = 'ideal/OfferValue/SET_OFFER_BROKERS';
export const SET_OFFER_BROKER = 'ideal/OfferValue/SET_OFFER_BROKER';
export const SET_OFFER_PRODUCTS = 'ideal/OfferValue/SET_OFFER_PRODUCTS';
export const SET_OFFER_PRODUCT = 'ideal/OfferValue/SET_OFFER_PRODUCT';
export const VALIDATE_USER_INPUT = 'ideal/OfferValue/VALIDATE_USER_INPUT';
export const SET_ERROR_MESSAGE = 'ideal/OfferValue/SET_ERROR_MESSAGE';
export const RESET = 'ideal/OfferValue/RESET';
